module.exports = __webpack_public_path__ + "static/img/25_pro.f4f2d79.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rz/25_pro.jpg
// module id = jF5n
// module chunks = 0